import { FEED_STATUS } from '../constants'

/*
  Helper functions for defining if feed provider is active
*/
export function isFeedOnline (status) {
  // return status === FEED_STATUS.ONLINE

  // Online if its not offline
  return status !== FEED_STATUS.OFFLINE
}

export function isFeedOffline (status) {
  return status === FEED_STATUS.OFFLINE
}
